import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { LOCAL_STORAGE_KEY } from '~/core/constants';
import { ApiUrl } from '~/core/enums';
import { RetailerSettings } from '~/core/models';
import { cleanCompanyCode } from '~/core/utils';

export interface RetailerSettingsParams {
  [LOCAL_STORAGE_KEY.USER_TOKEN]?: string;
}

const MAX_RETRIES = 1;

const retailerSettingsService = easyEstimatorApi.injectEndpoints({
  endpoints: ({ query }) => ({
    fetchRetailerSettings: query<RetailerSettings, RetailerSettingsParams>({
      query: (params) => ({
        url: ApiUrl.RETAILER_SETTINGS,
        method: 'GET',
        params,
      }),
      transformResponse: ({ companyCode, ...rest }: RetailerSettings) => ({
        ...rest,
        companyCode: cleanCompanyCode(companyCode),
      }),
      extraOptions: { maxRetries: MAX_RETRIES },
    }),
  }),
});

export const { useFetchRetailerSettingsQuery } = retailerSettingsService;
